var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useCallback, useMemo } from "react";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
// import MuiPhoneNumber from "material-ui-phone-number";
import { useForm } from "../../../../../hooks/UseForm";
import { modalFields } from "../data";
import { Button } from "../../../../Button";
import styled from "@mui/material/styles/styled";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { isProviderPhoneValid } from "./handlers";
const buttons = [
    {
        label: "Cancel",
        size: "small",
        variant: "contained",
        type: "button",
        className: "Close",
    },
    {
        label: "Reset",
        size: "small",
        variant: "contained",
        type: "button",
        className: "Clear",
    },
    ,
    {
        label: "Save",
        size: "small",
        variant: "contained",
        type: "button",
        className: "save",
    },
];
const dollarComponent = {
    startAdornment: React.createElement("p", { style: { marginTop: 13, marginRight: 10 } }, "$"),
};
const StyleWrapper = styled("div")(() => {
    return {
        form: {
            display: "flex",
            flexDirection: "column",
            gap: 10,
            textarea: {
                borderColor: "rgba(0, 0, 0, 0.23)",
                fontSize: 16,
                fontFamily: "inherit",
                padding: 14,
            },
            ".MuiOutlinedInput-notchedOutline": {
                borderRadius: 0,
            },
        },
    };
});
const ListForm = (props) => {
    var _a;
    const [imgRawInfo, setImgRawInfo] = React.useState("");
    const { values, onChange } = useForm(() => { }, Object.assign({}, props.selectedReference));
    const fields = useMemo(() => {
        return modalFields[props.selectedItem.id];
    }, [props.selectedItem]);
    const imageHandler = (imgInfo) => __awaiter(void 0, void 0, void 0, function* () {
        return setImgRawInfo(imgInfo);
    });
    const buttonHandler = useCallback((btnDetails) => {
        return () => __awaiter(void 0, void 0, void 0, function* () {
            var _a, _b, _c;
            if (btnDetails.label === "Cancel") {
                (_a = fields === null || fields === void 0 ? void 0 : fields.fields) === null || _a === void 0 ? void 0 : _a.forEach((field) => {
                    field.isValid = false;
                });
                return props.setModalValues(null);
            }
            if (btnDetails.label === "Reset") {
                if (!fields.component) {
                    (_b = fields === null || fields === void 0 ? void 0 : fields.fields) === null || _b === void 0 ? void 0 : _b.forEach((field = "") => {
                        values[field.name] = "";
                    });
                    props.setModalValues(values);
                }
                else if (fields.component) {
                    (_c = [fields.name]) === null || _c === void 0 ? void 0 : _c.forEach((field = "") => {
                        values[field] = "";
                    });
                    props.setModalValues(values);
                }
            }
            else {
                if (fields.component && imgRawInfo) {
                    values[fields.name || ""] = imgRawInfo;
                }
                // if (!isProviderPhoneValid(fields, values))
                //   return alert("Pleae provide valid phone number");
                props.setModalValues(values);
            }
        });
    }, [values, imgRawInfo]);
    const isValidFiled = (field, e) => {
        if (e.target.value)
            field.isValid = true;
        else
            field.isValid = false;
        onChange(e);
    };
    const validPhoneNumber = (field, e) => {
        if (isProviderPhoneValid(field, e.target.value)) {
            field.isValid = true;
        }
        else {
            field.isValid = false;
        }
        onChange(e);
    };
    return (React.createElement("div", null,
        React.createElement(Dialog, { open: true, "aria-labelledby": "alert-dialog-title", "aria-describedby": "alert-dialog-description" },
            React.createElement(DialogTitle, { id: "alert-dialog-title" },
                modalFields[props.selectedItem.id].title,
                React.createElement(IconButton, { "aria-label": "close", onClick: buttonHandler({ label: "Cancel" }), sx: {
                        right: 0,
                        left: 5,
                        color: (theme) => theme.palette.grey[500],
                    } },
                    React.createElement(CloseIcon, null))),
            React.createElement(DialogContent, null, fields.component ? (React.createElement(fields.component, { dragDropHandler: imageHandler, imgPath: values[props.selectedItem.id || ""] || "" })) : (React.createElement(StyleWrapper, null,
                React.createElement("form", { onSubmit: props.setUpadtedValues, style: { marginTop: 10 } }, (_a = fields === null || fields === void 0 ? void 0 : fields.fields) === null || _a === void 0 ? void 0 : _a.map((field) => {
                    if ((field === null || field === void 0 ? void 0 : field.type) === "telephone") {
                        return (React.createElement(PhoneNumberField, Object.assign({}, field, { onChange: (e) => validPhoneNumber(field, e), value: values[field.name], required: true })));
                    }
                    return (React.createElement(TextField, Object.assign({}, field, { required: true, onChange: (e) => isValidFiled(field, e), value: values[field.name], sx: { marginTop: "10px" }, InputProps: field.name.includes("mount") ? dollarComponent : null })));
                }))))),
            React.createElement(DialogActions, null, Object.values(values).join("").length &&
                buttons.map((btn) => {
                    var _a;
                    let disabled = btn.label === "Save"
                        ? !fields.fields.every((ele) => ele.isValid)
                        : btn.label === "Reset"
                            ? !fields.fields.find(({ name }) => values[name])
                            : false;
                    disabled = ((_a = fields === null || fields === void 0 ? void 0 : fields.fields) === null || _a === void 0 ? void 0 : _a.length) ? disabled : (!imgRawInfo && !values[props.selectedItem.id]);
                    return (React.createElement(Button, Object.assign({}, btn, { disabled: disabled, onClick: buttonHandler(btn) })));
                })))));
};
export default React.memo(ListForm);
// const CssPhone = styled(MuiPhoneNumber)(() => {
//   return {
//     ".MuiInputBase-root": {
//       backgroundColor: "#fff !important",
//       border: "1px solid #ccc",
//       borderRadius: "0 !important",
//     },
//     ".MuiFormLabel-root": {
//       "&:hover:not($disabled):not($focused):not($error):before": {
//         borderBottom: "2px solid #533278",
//         color: "#533278",
//       },
//       "&.MuiFilledInput-underline.Mui-focused:after": {
//         borderBottom: "2px solid #533278",
//         color: "#533278",
//       },
//     },
//   };
// });
const PhoneNumberField = (_a) => {
    var { value, onChange } = _a, fields = __rest(_a, ["value", "onChange"]);
    return (React.createElement(React.Fragment, null));
};
